import Interceptor from "./Interceptor";

/**
 * Usage API Service
 * Endpoints for resource usage tracking, history, and alerts
 */

// Get current org's full usage breakdown
export const fetchUsage = async () => {
  const response = await Interceptor.get("/usage");
  return response.data;
};

// Get usage snapshots for charts
export const fetchUsageHistory = async (days = 30, type = "daily") => {
  const response = await Interceptor.get(
    `/usage/history?days=${days}&type=${type}`,
  );
  return response.data;
};

// Get per-site resource breakdown
export const fetchUsageBreakdown = async () => {
  const response = await Interceptor.get("/usage/breakdown");
  return response.data;
};

// Get active usage alerts
export const fetchUsageAlerts = async () => {
  const response = await Interceptor.get("/usage/alerts");
  return response.data;
};

// Dismiss a usage alert
export const acknowledgeUsageAlert = async (alertId) => {
  const response = await Interceptor.put(
    `/usage/alerts/${alertId}/acknowledge`,
  );
  return response.data;
};
